export const SASS_PAYMENT_FEATURES = [
    'Нейросеть для бизнеса',
    'Загрузка тяжёлых файлов  до 100 ГБ',
    'Свободное место в телефоне',
    'Виджеты планирования',
];
